import React from "react";
import { Tooltip } from "antd";

export default function Truncate({
  text,
  chars = 15,
}: {
  text: string | null | undefined;
  chars?: number;
}) {
  return (
    <Tooltip title={text}>
      <span
        style={{
          maxWidth: "250px",
          display: "block",
          overflowX: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          margin: "0 auto",
        }}>
        {/* {text && text.slice(0, chars)}
        {text && text.length > chars ? "..." : ""} */}
        {text}
      </span>
    </Tooltip>
  );
}
